import React from 'react';

import LoupeSvg from '../../svg/Loupe';

import styles from './Image.module.scss';


const Image = (props) => {
  return (
    <div className={styles.Image} onClick={props.onClick}>
      <img alt='' src={props.src}/>
      <div className={styles.Hover}>
        <LoupeSvg className={styles.LoupeSvg}/>
      </div>
    </div>
  );
};

Image.defaultProps = {
  src: '',
};

export default Image;
